import { render, staticRenderFns } from "./genUser.vue?vue&type=template&id=89b97e9c&scoped=true&"
import script from "./genUser.vue?vue&type=script&lang=js&"
export * from "./genUser.vue?vue&type=script&lang=js&"
import style0 from "./genUser.vue?vue&type=style&index=0&id=89b97e9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b97e9c",
  null
  
)

export default component.exports